import { memo } from "react";

import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";

// -----------------------------------------------------------------------------

const GCPConnectSetupPageError = memo(function GCPConnectSetupPageError({
  show,
  loading,
  onTryAgain,
  children,
}: GCPConnectSetupPageErrorProps) {
  return show ? (
    <Alert severity="error">
      {children ?? "There was an error"}
      <LoadingButton
        variant="contained"
        loading={loading}
        color="error"
        sx={{ mt: 2 }}
        onClick={onTryAgain as React.MouseEventHandler<HTMLButtonElement>}
      >
        Try Again
      </LoadingButton>
    </Alert>
  ) : null;
});

export default GCPConnectSetupPageError;

// -----------------------------------------------------------------------------

interface GCPConnectSetupPageErrorProps {
  show: boolean;
  loading: boolean;
  onTryAgain: Function;
  children: React.ReactNode;
}
